import { useNullableContext } from '~/common/contexts/nullableContext';
import { StepComponentsContext } from '../../StepComponentsContext';
import { StepComponentsContextType } from '../../types/StepComponentsContextType';

export const useStepComponentsContext = (): StepComponentsContextType => {
  const stepComponentsContext = useNullableContext(
    StepComponentsContext,
    'useStepComponentsContext must be used within a StepComponentsContext.Provider',
  );

  return stepComponentsContext;
};
